var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 18,
    viewBox: "0 0 15 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.4014 6.68543H10.828V1.73964C10.828 1.19561 10.3827 0.750488 9.83838 0.750488H5.88005C5.33577 0.750488 4.89046 1.19561 4.89046 1.73964V6.68543H3.31702C2.4363 6.68543 1.99098 7.75372 2.61442 8.37689L7.15661 12.9171C7.54255 13.3029 8.16598 13.3029 8.55192 12.9171L13.0941 8.37689C13.7175 7.75372 13.2821 6.68543 12.4014 6.68543ZM0.932129 16.577C0.932129 17.121 1.37744 17.5662 1.92171 17.5662H13.7967C14.341 17.5662 14.7863 17.121 14.7863 16.577C14.7863 16.033 14.341 15.5878 13.7967 15.5878H1.92171C1.37744 15.5878 0.932129 16.033 0.932129 16.577Z",
    fill: "#5F46FE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.a8df47a3988267ef239eb348433829d9.svg";
export { ForwardRef as ReactComponent };